
<mat-toolbar color="primary">
    <span>Labelling Tool <span *ngIf="appVersion" class="small">(v.{{ appVersion }})</span></span>
    <span class="doc-title" *ngIf="isLoaded && currentDBEntry">{{currentDBEntry.doc_uri}}</span>
    <span>
        <a class="logout" mat-flat-button color="accent" (click)="logoutFromPage()">Logout</a>
    </span>
</mat-toolbar>
<div class="labelling-stage">
    <div *ngIf="(!isLoaded) || (isLoaded && docLoading)" class="centered">
        <mat-spinner></mat-spinner>
    </div>
    <div class="user-bar">
        <p>Bearbeiter: {{ author }}</p>
        <p *ngIf="authService.isLoggedIn()">Login gültig <mat-icon class="success">done</mat-icon></p>
        <p *ngIf="!authService.isLoggedIn()">
            <a class="mat-button" [routerLink]="['/login-page']">Login</a>
        </p>
        <div *ngIf="!docLoading" class="user-history">
            <mat-expansion-panel id="historyPanel" (opened)="getDoneDocuments()">
                <mat-expansion-panel-header>
                    <mat-panel-title class="headline">
                        <ng-container *ngIf="author !== 'Reviewer'; else reviewer">Historie</ng-container>
                        <ng-template #reviewer>In Review <span *ngIf="docHistCount" class="label done">{{ docHistCount }}</span></ng-template>
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <ng-template matExpansionPanelContent>
                    <p *ngIf="docHistory.length === 0" class="padding-left-right">Keine Einträge vorhanden.</p>
                    <ng-container *ngFor="let docEntry of docHistory">
                        <p>
                            <a class="link padding-left-right"
                               mat-button
                               (click)="loadNextDocument(docEntry.doc_uri, docEntry.state)">
                                {{ docEntry.doc_name }}
                            </a>
                            <span *ngIf="docEntry.state === 'review'" class="label review">Review</span>
                            <span *ngIf="docEntry.state === 'done'" class="label done">Done</span>
                        </p>

                    </ng-container>
                </ng-template>
            </mat-expansion-panel>
        </div>
    </div>
    <pdf-viewer *ngIf="pdfObject"
                [src]="pdfObject"
                [show-all]="false"
                [render-text]="false"
                [page]="page"
                [rotation]="pdfRotation"
                [zoom]="pdfZoom"
                (after-load-complete)="afterLoadComplete($event)"
                (error)="onPdfError($event)"
    ></pdf-viewer>

    <div class="button-bar" *ngIf="isLoaded && !docLoading && pdfObject">
        <div class="buttons-row">
            <button class="prev-page" mat-flat-button color="primary" (click)="prevPage()" [disabled]="page === 1"
                    title="Sie können auch die Pfeil-nach-Links Taste auf Ihrer Tastatur benutzen."><mat-icon>keyboard_arrow_left</mat-icon>Prev</button>
            <span class="page-counter">{{ page }} / {{ totalPages }}</span>
            <button class="next-page" mat-flat-button color="primary" (click)="nextPage()" [disabled]="page > totalPages"
                    title="Sie können auch die Pfeil-nach-Rechts Taste auf Ihrer Tastatur benutzen.">
                {{ page < totalPages ? 'Next' : 'Save&nbsp;' }}<mat-icon *ngIf="page < totalPages">keyboard_arrow_right</mat-icon><mat-icon *ngIf="page === totalPages">save</mat-icon>
            </button>
        </div>
        <div class="buttons-row">
            <button class="turnCcw" mat-flat-button color="accent" (click)="rotateDocumentCclockwise()"
                    title="Das Dokument kann in 90 Grad Schritten entgegen dem Uhrzeigersinn gedreht werden."><mat-icon>rotate_left</mat-icon></button>
            <button class="turnReset" mat-flat-button color="accent" (click)="rotateDocumentReset()"
                    title="Zurücksetzen">Zurück</button>
            <button class="turnCw" mat-flat-button color="accent" (click)="rotateDocumentClockwise()"
                    title="Das Dokument kann in 90 Grad Schritten im Uhrzeigersinn gedreht werden."><mat-icon>rotate_right</mat-icon></button>
        </div>
        <div class="buttons-row">
            <button class="zoomOut" mat-flat-button color="accent" (click)="zoomDocumentOut()"
                    title="Das Dokument kann kleiner dargestellt werden."><mat-icon>zoom_out</mat-icon></button>
            <button class="zoomReset" mat-flat-button color="accent" (click)="zoomDocumentReset()"
                    title="Zurücksetzen">1:1</button>
            <button class="zoomIn" mat-flat-button color="accent" (click)="zoomDocumentIn()"
                    title="Das Dokument kann grösser dargestellt werden."><mat-icon>zoom_in</mat-icon></button>
        </div>
        <div class="comment-bar" *ngIf="hasComment" [innerHTML]="hasComment"></div>
        <div class="note-bar" *ngIf="author !== 'Reviewer'">
            <h4>Notizen</h4>
            <textarea rows="10"
                    class="full-width"
                    [(ngModel)]="notes">
            </textarea>
        </div>
    </div>
</div>

<div *ngIf="isLoaded && pdfObject" class="bottom-bar">
    <span class="link"><a mat-stroked-button color="primary" href="https://wiki.hypoport.local/pages/viewpage.action?spaceKey=DNA&title=Smart+Cat+Annonations-Richtlinien" target="_blank">Fragen zum Labeling?</a></span>
    <ng-select [items]="cats"
               [(ngModel)]="selectedCat"
               (change)="docHardtoRead=false"
               autofocus
               title="Fangen Sie einfach an zu tippen oder klappen Sie die Liste auf, um einen Eintrag auszusuchen.">
    </ng-select>
    <mat-checkbox [(ngModel)]="docHardtoRead">Dokument schwer zu erkennen</mat-checkbox>
</div>



